import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { MonthlySurplusSliderWithText } from './MonthlySurplusSliderWithText';

export default buildFacetDesignOverride()
  .nameOverride('monthlySurplus', {
    _component: () => MonthlySurplusSliderWithText,
  }, overrideReadOnly);
